import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Button,
  Divider,
  Dropdown,
  Input,
  Label,
  Checkbox
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardEpisodeOfCareUX = (props: any) => {
    return(
      <div
        id="CardEpisodeOfCareUX-div-0"
        style={{ width : "100%", height: "100%" , padding: "1rem"}}>
        <Form
          id="CardEpisodeOfCareUX-Form-26">
          <FormGroup
            id="CardEpisodeOfCareUX-FormGroup-27"
            inline={true}>
            <FormField
              id="CardEpisodeOfCareUX-FormField-28"
              inline={true}
              width={6}>
              <label
                id="CardEpisodeOfCareUX-label-31"
                style={{ fontSize: "1.2rem"}}>
                {props.languageUX === "en" ? "Episode of Care" : "Episode of Care"}
              </label>
              <div
                id="CardEpisodeOfCareUX-div-81">
                {props.loadingCheckbox}
              </div>
            </FormField>
            <FormField
              id="CardEpisodeOfCareUX-FormField-30"
              style={{flex: 1}}>
            </FormField>
            <FormField
              id="CardEpisodeOfCareUX-FormField-32"
              style={{padding: 0}}>
              <Button
                color="green"
                id="CardEpisodeOfCareUX-Button-34"
                onClick={props.onNewEpisode}
                size="small">
                {props.languageUX === "en" ? "Create New Episode" : "Create New Episode"}
              </Button>
            </FormField>
          </FormGroup>
        </Form>
        <div
          id="CardEpisodeOfCareUX-div-35">
          
          <Table
            NoDataComponent={()=>null}
            data={props.episodeList}
            getTrProps={props.onGetTrProps}
            headers="Episode no.,Episode type,Episode name,Doctor,Started,Finished"
            id="CardEpisodeOfCareUX-Table-36"
            keys="episode_no,episodeTypeName,name,doctor_name,firstEncounterCreated,finishedAt"
            minRows="5"
            showPagination={false}
            style={{height: "200px"}}>
          </Table>
        </div>
        <div
          id="CardEpisodeOfCareUX-div-37"
          style={{display:props.episodeDetail?"":"none"}}>
          
          <Divider
            id="CardEpisodeOfCareUX-Divider-39">
          </Divider>
          <Form
            id="CardEpisodeOfCareUX-Form-40">
            <FormGroup
              id="CardEpisodeOfCareUX-FormGroup-41"
              inline={true}>
              <FormField
                id="CardEpisodeOfCareUX-FormField-43"
                inline={true}>
                <label
                  id="CardEpisodeOfCareUX-label-47"
                  style={{minWidth: "6rem"}}>
                  {props.languageUX === "en" ? "Episode no." : "ตอนที่."}
                </label>
                <Label
                  color="blue"
                  id="CardEpisodeOfCareUX-Label-52"
                  style={{minWidth:"7rem"}}>
                  {props.episodeDetail?.episode_no??"\u00A0"}
                </Label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEpisodeOfCareUX-FormGroup-42"
              inline={true}>
              <FormField
                id="CardEpisodeOfCareUX-FormField-45"
                inline={true}
                width={8}>
                <label
                  id="CardEpisodeOfCareUX-label-48"
                  style={{minWidth: "6rem"}}>
                  {props.languageUX === "en" ? "Episode type" : "ประเภทตอน"}
                </label>
                <Dropdown
                  clearable={true}
                  fluid={true}
                  id="CardEpisodeOfCareUX-Dropdown-50"
                  name="episode_type"
                  onChange={props.onChangeValue}
                  options={props.episodeTypeOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.episodeDetail?.episode_type??""}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardEpisodeOfCareUX-FormField-46"
                inline={true}
                width={8}>
                <label
                  id="CardEpisodeOfCareUX-label-49"
                  style={{minWidth: "6rem"}}>
                  {props.languageUX === "en" ? "Episode name" : "ชื่อตอน"}
                </label>
                <Input
                  fluid={true}
                  id="CardEpisodeOfCareUX-Input-51"
                  name="name"
                  onChange={props.onChangeValue}
                  value={props.episodeDetail?.name??""}>
                </Input>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEpisodeOfCareUX-FormGroup-53"
              inline={true}>
              <FormField
                id="CardEpisodeOfCareUX-FormField-54"
                inline={true}
                width={8}>
                <label
                  id="CardEpisodeOfCareUX-label-55"
                  style={{minWidth: "6rem"}}>
                  {props.languageUX === "en" ? "Doctor" : "หมอ"}
                </label>
                <div
                  id="CardEpisodeOfCareUX-div-56"
                  style={{width: "100%"}}>
                  {props.searchBoxDoctor}
                </div>
              </FormField>
              <FormField
                id="CardEpisodeOfCareUX-FormField-57"
                inline={true}
                width={8}>
                <Checkbox
                  checked={props.episodeDetail?.is_finished??""}
                  id="CardEpisodeOfCareUX-Checkbox-58"
                  label={props.languageUX === "en" ? "Finish" : "เสร็จ"}
                  name="is_finished"
                  onChange={props.onChangeValue}>
                </Checkbox>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEpisodeOfCareUX-FormGroup-59"
              inline={true}
              style={{marginBottom: "0.5rem"}}>
              <FormField
                id="CardEpisodeOfCareUX-FormField-60"
                inline={true}>
                <label
                  id="CardEpisodeOfCareUX-label-61">
                  {props.languageUX === "en" ? "Encounter in this Episode" : "การพบกันในตอนนี้"}
                </label>
              </FormField>
            </FormGroup>
          </Form>
          <div
            id="CardEpisodeOfCareUX-div-62">
            
            <Table
              NoDataComponent={props.NoDataComponent}
              data={props.episodeEncounterList}
              headers=",Encounter,Division,Doctor,Status,Start,Del,"
              id="CardEpisodeOfCareUX-Table-63"
              keys="checkbox,number,division_name,doctor_name,status_name,startDate,canceledDate,delete"
              minRows={1}
              showPagination={false}
              sortable={false}
              widths="60,120,^120,^120,^110,^100,^100,85">
            </Table>
          </div>
          <Form
            id="CardEpisodeOfCareUX-Form-84">
            <FormGroup
              id="CardEpisodeOfCareUX-FormGroup-97"
              inline={true}
              style={{margin: "1rem 0 0.25rem"}}>
              <FormField
                id="CardEpisodeOfCareUX-FormField-99">
                <label
                  id="CardEpisodeOfCareUX-label-104">
                  {props.languageUX === "en" ? "Patient's Encounter (No Episode)" : "การพบผู้ป่วย (ไม่มีตอน)"}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEpisodeOfCareUX-FormGroup-98"
              inline={true}
              style={{marginBottom: "0.5rem"}}>
              <FormField
                id="CardEpisodeOfCareUX-FormField-100"
                inline={true}>
                <div
                  id="CardEpisodeOfCareUX-div-113">
                  {props.toggleSwitch}
                </div>
              </FormField>
              <FormField
                id="CardEpisodeOfCareUX-FormField-101"
                inline={true}
                style={{display: props.filterEncounter?.include_expired? "flex":"none", alignItems: "center"}}>
                <label
                  id="CardEpisodeOfCareUX-label-105"
                  style={{minWidth: "max-content", fontWeight: "normal"}}>
                  {props.languageUX === "en" ? "Encounter date" : "วันที่พบกัน"}
                </label>
                <div
                  className="ui form size mini"
                  id="CardEpisodeOfCareUX-div-109"
                  style={{width: "100%"}}>
                  {}
                  <DateTextBox
                    id="CardEpisodeOfCareUX-DateTextBox-111"
                    onChange={(value: string)=>{props.onChangeFilterEncounter?.(null, {value, name: "started"})}}
                    value={props.filterEncounter?.started || ""}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardEpisodeOfCareUX-FormField-102"
                inline={true}
                style={{display: props.filterEncounter?.include_expired? "flex":"none", alignItems: "center"}}>
                <label
                  id="CardEpisodeOfCareUX-label-106"
                  style={{minWidth: "max-content", fontWeight: "normal"}}>
                  {props.languageUX === "en" ? "to" : "ถึง"}
                </label>
                <div
                  className="ui form size mini"
                  id="CardEpisodeOfCareUX-div-108"
                  style={{width: "100%"}}>
                  
                  <DateTextBox
                    id="CardEpisodeOfCareUX-DateTextBox-110"
                    onChange={(value: string)=>{props.onChangeFilterEncounter?.(null, {value, name: "ended"})}}
                    value={props.filterEncounter?.ended || ""}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardEpisodeOfCareUX-FormField-103"
                style={{display: props.filterEncounter?.include_expired? "flex":"none"}}>
                <div
                  id="CardEpisodeOfCareUX-div-112">
                  {props.buttonSearchEncounter}
                </div>
              </FormField>
            </FormGroup>
          </Form>
          <div
            id="CardEpisodeOfCareUX-div-66">
            
            <Table
              NoDataComponent={props.NoDataComponent}
              data={props.activeEncounterList}
              headers={props.tableHeaders}
              id="CardEpisodeOfCareUX-Table-67"
              keys="checkbox,number,division_name,doctor_name,status_name,startDate,canceledDate,delete"
              minRows={5}
              showPagination={false}
              sortable={false}
              style={{height: "250px"}}
              widths="60,120,^120,^120,^110,^100,^100,85">
            </Table>
          </div>
          <Form
            id="CardEpisodeOfCareUX-Form-73">
            <FormGroup
              id="CardEpisodeOfCareUX-FormGroup-114"
              inline={true}
              style={{marginTop: "0.75rem"}}>
              <FormField
                id="CardEpisodeOfCareUX-FormField-115"
                style={{flex:1}}>
              </FormField>
              <FormField
                id="CardEpisodeOfCareUX-FormField-116"
                style={{ padding: 0}}>
                <div
                  id="CardEpisodeOfCareUX-div-117">
                  {props.pagination}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardEpisodeOfCareUX-FormGroup-77"
              inline={true}
              style={{marginTop: "1.25rem"}}>
              <FormField
                id="CardEpisodeOfCareUX-FormField-78"
                style={{flex: 1}}>
              </FormField>
              <FormField
                id="CardEpisodeOfCareUX-FormField-82">
                <Button
                  color="red"
                  id="CardEpisodeOfCareUX-Button-83"
                  onClick={props.onDeleteEpisode}
                  size="small"
                  style={{display: props.showDeleteEpisode?"":"none"}}>
                  {props.languageUX === "en" ? "DELETE EPISODE" : "ลบตอน"}
                </Button>
              </FormField>
              <FormField
                id="CardEpisodeOfCareUX-FormField-79"
                style={{padding: 0}}>
                <div
                  id="CardEpisodeOfCareUX-div-80">
                  {props.buttonSave}
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
      </div>
    )
}

CardEpisodeOfCareUX.displayName = "CardEpisodeOfCareUX";
export default React.memo(CardEpisodeOfCareUX)

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","language":"EN","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Thu Nov 20 2025 07:17:11 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ width : \"100%\", height: \"100%\" , padding: \"1rem\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-Form-26"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "FormGroup",
      "parent": 26,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormGroup-27"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormField-28"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormField-30"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "label",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": "Episode of Care",
          "valueEN": "Episode of Care"
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-label-31"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"1.2rem\"}"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "FormField",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormField-32"
        },
        "style": {
          "type": "code",
          "value": "{padding: 0}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "Button",
      "parent": 32,
      "props": {
        "children": {
          "type": "value",
          "value": "Create New Episode",
          "valueEN": "Create New Episode"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-Button-34"
        },
        "onClick": {
          "type": "code",
          "value": "props.onNewEpisode"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-div-35"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 36,
      "name": "Table",
      "parent": 35,
      "props": {
        "NoDataComponent": {
          "type": "code",
          "value": "()=>null"
        },
        "data": {
          "type": "code",
          "value": "props.episodeList"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.onGetTrProps"
        },
        "headers": {
          "type": "value",
          "value": "Episode no.,Episode type,Episode name,Doctor,Started,Finished"
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-Table-36"
        },
        "keys": {
          "type": "value",
          "value": "episode_no,episodeTypeName,name,doctor_name,firstEncounterCreated,finishedAt"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"200px\"}"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-div-37"
        },
        "style": {
          "type": "code",
          "value": "{display:props.episodeDetail?\"\":\"none\"}"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "Divider",
      "parent": 37,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-Divider-39"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "Form",
      "parent": 37,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-Form-40"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormGroup",
      "parent": 40,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormGroup-41"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "FormGroup",
      "parent": 40,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormGroup-42"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "FormField",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormField-43"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormField",
      "parent": 42,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormField-45"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "FormField",
      "parent": 42,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormField-46"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "label",
      "parent": 43,
      "props": {
        "children": {
          "type": "value",
          "value": "ตอนที่.",
          "valueEN": "Episode no."
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-label-47"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"6rem\"}"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "label",
      "parent": 45,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทตอน",
          "valueEN": "Episode type"
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-label-48"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"6rem\"}"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "label",
      "parent": 46,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อตอน",
          "valueEN": "Episode name"
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-label-49"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"6rem\"}"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "Dropdown",
      "parent": 45,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-Dropdown-50"
        },
        "name": {
          "type": "value",
          "value": "episode_type"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.episodeTypeOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.episodeDetail?.episode_type??\"\""
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "Input",
      "parent": 46,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-Input-51"
        },
        "name": {
          "type": "value",
          "value": "name"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "code",
          "value": "props.episodeDetail?.name??\"\""
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "Label",
      "parent": 43,
      "props": {
        "children": {
          "type": "code",
          "value": "props.episodeDetail?.episode_no??\"\\u00A0\""
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-Label-52"
        },
        "style": {
          "type": "code",
          "value": "{minWidth:\"7rem\"}"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "FormGroup",
      "parent": 40,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormGroup-53"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "FormField",
      "parent": 53,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormField-54"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "label",
      "parent": 54,
      "props": {
        "children": {
          "type": "value",
          "value": "หมอ",
          "valueEN": "Doctor"
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-label-55"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"6rem\"}"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "div",
      "parent": 54,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchBoxDoctor"
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-div-56"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "FormField",
      "parent": 53,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormField-57"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "Checkbox",
      "parent": 57,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.episodeDetail?.is_finished??\"\""
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-Checkbox-58"
        },
        "label": {
          "type": "value",
          "value": "เสร็จ",
          "valueEN": "Finish"
        },
        "name": {
          "type": "value",
          "value": "is_finished"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "FormGroup",
      "parent": 40,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormGroup-59"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "FormField",
      "parent": 59,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormField-60"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "label",
      "parent": 60,
      "props": {
        "children": {
          "type": "value",
          "value": "การพบกันในตอนนี้",
          "valueEN": "Encounter in this Episode"
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-label-61"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 62,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-div-62"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 63,
      "name": "Table",
      "parent": 62,
      "props": {
        "NoDataComponent": {
          "type": "code",
          "value": "props.NoDataComponent"
        },
        "data": {
          "type": "code",
          "value": "props.episodeEncounterList"
        },
        "headers": {
          "type": "value",
          "value": ",Encounter,Division,Doctor,Status,Start,Del,"
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-Table-63"
        },
        "keys": {
          "type": "value",
          "value": "checkbox,number,division_name,doctor_name,status_name,startDate,canceledDate,delete"
        },
        "minRows": {
          "type": "code",
          "value": "1"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "sortable": {
          "type": "code",
          "value": "false"
        },
        "widths": {
          "type": "value",
          "value": "60,120,^120,^120,^110,^100,^100,85"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-div-66"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 67,
      "name": "Table",
      "parent": 66,
      "props": {
        "NoDataComponent": {
          "type": "code",
          "value": "props.NoDataComponent"
        },
        "data": {
          "type": "code",
          "value": "props.activeEncounterList"
        },
        "headers": {
          "type": "code",
          "value": "props.tableHeaders"
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-Table-67"
        },
        "keys": {
          "type": "value",
          "value": "checkbox,number,division_name,doctor_name,status_name,startDate,canceledDate,delete"
        },
        "minRows": {
          "type": "code",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "sortable": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"250px\"}"
        },
        "widths": {
          "type": "value",
          "value": "60,120,^120,^120,^110,^100,^100,85"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 73,
      "name": "Form",
      "parent": 37,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-Form-73"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 77,
      "name": "FormGroup",
      "parent": 73,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormGroup-77"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1.25rem\"}"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "FormField",
      "parent": 77,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormField-78"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 79,
      "name": "FormField",
      "parent": 77,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormField-79"
        },
        "style": {
          "type": "code",
          "value": "{padding: 0}"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "div",
      "parent": 79,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-div-80"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": null,
      "id": 81,
      "name": "div",
      "parent": 28,
      "props": {
        "children": {
          "type": "code",
          "value": "props.loadingCheckbox"
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-div-81"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 82,
      "name": "FormField",
      "parent": 77,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormField-82"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 83,
      "name": "Button",
      "parent": 82,
      "props": {
        "children": {
          "type": "value",
          "value": "ลบตอน",
          "valueEN": "DELETE EPISODE"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-Button-83"
        },
        "name": {
          "type": "value",
          "value": ""
        },
        "onClick": {
          "type": "code",
          "value": "props.onDeleteEpisode"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showDeleteEpisode?\"\":\"none\"}"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "Form",
      "parent": 37,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-Form-84"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 97,
      "name": "FormGroup",
      "parent": 84,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormGroup-97"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"1rem 0 0.25rem\"}"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 98,
      "name": "FormGroup",
      "parent": 84,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormGroup-98"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"0.5rem\"}"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "FormField",
      "parent": 97,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormField-99"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 100,
      "name": "FormField",
      "parent": 98,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormField-100"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "FormField",
      "parent": 98,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormField-101"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filterEncounter?.include_expired? \"flex\":\"none\", alignItems: \"center\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "FormField",
      "parent": 98,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormField-102"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filterEncounter?.include_expired? \"flex\":\"none\", alignItems: \"center\"}"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "FormField",
      "parent": 98,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormField-103"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filterEncounter?.include_expired? \"flex\":\"none\"}"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "label",
      "parent": 99,
      "props": {
        "children": {
          "type": "value",
          "value": "การพบผู้ป่วย (ไม่มีตอน)",
          "valueEN": "Patient's Encounter (No Episode)"
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-label-104"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": null,
      "id": 105,
      "name": "label",
      "parent": 101,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่พบกัน",
          "valueEN": "Encounter date"
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-label-105"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"normal\"}"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": null,
      "id": 106,
      "name": "label",
      "parent": 102,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-label-106"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"normal\"}"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": null,
      "id": 108,
      "name": "div",
      "parent": 102,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form size mini"
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-div-108"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": null,
      "id": 109,
      "name": "div",
      "parent": 101,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form size mini"
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-div-109"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 110,
      "name": "DateTextBox",
      "parent": 108,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-DateTextBox-110"
        },
        "onChange": {
          "type": "code",
          "value": "(value: string)=>{props.onChangeFilterEncounter?.(null, {value, name: \"ended\"})}"
        },
        "value": {
          "type": "code",
          "value": "props.filterEncounter?.ended || \"\""
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 111,
      "name": "DateTextBox",
      "parent": 109,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-DateTextBox-111"
        },
        "onChange": {
          "type": "code",
          "value": "(value: string)=>{props.onChangeFilterEncounter?.(null, {value, name: \"started\"})}"
        },
        "value": {
          "type": "code",
          "value": "props.filterEncounter?.started || \"\""
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": null,
      "id": 112,
      "name": "div",
      "parent": 103,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearchEncounter"
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-div-112"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": null,
      "id": 113,
      "name": "div",
      "parent": 100,
      "props": {
        "children": {
          "type": "code",
          "value": "props.toggleSwitch"
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-div-113"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 114,
      "name": "FormGroup",
      "parent": 73,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormGroup-114"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"0.75rem\"}"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 115,
      "name": "FormField",
      "parent": 114,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormField-115"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 116,
      "name": "FormField",
      "parent": 114,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-FormField-116"
        },
        "style": {
          "type": "code",
          "value": "{ padding: 0}"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": null,
      "id": 117,
      "name": "div",
      "parent": 116,
      "props": {
        "children": {
          "type": "code",
          "value": "props.pagination"
        },
        "id": {
          "type": "value",
          "value": "CardEpisodeOfCareUX-div-117"
        }
      },
      "seq": 117,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": true,
  "name": "CardEpisodeOfCareUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "language": "EN",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 75
}

*********************************************************************************** */
